class SearchModal extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    if (this.detailsContainer) { // guard: details element may be absent
      this.detailsContainer.addEventListener(
        'keyup',
        (event) => event.code && event.code.toUpperCase() === 'ESCAPE' && this.close()
      );
    }
    if (this.summaryToggle) { // guard: summary element may be absent
      this.summaryToggle.addEventListener(
        'click',
        this.onSummaryClick.bind(this)
      );
      this.summaryToggle.setAttribute('role', 'button');
    }
    const closeBtn = this.querySelector('button[type="button"]');
    if (closeBtn) { // guard: close button may not be present
      closeBtn.addEventListener(
        'click',
        this.close.bind(this)
      );
    }
    const resetBtn = this.querySelector('button[type="reset"]');
    if (resetBtn) { // guard: reset button may not be present
      resetBtn.addEventListener(
        'click',
        this.reset.bind(this)
      );
    }
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close();
  }

  open() {
    setScrollbarWidth();
    setHeaderBottomPosition();
    
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
      
    this.detailsContainer.setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('search-modal--open');

    /* Fix by Zenyth - ZA 42354, 41056, 42343, 41054, 42360, 41061, 42361, 40999, 40980, 41057 (predictive-search dialog a11y, 2.1.2 / 2.4.3) */
    /* Related: sections/predictive-search.liquid, snippets/search-modal.liquid, assets/predictive-search.js, assets/predictive-search.min.js, assets/zenyth_styles.css */
    this.dialog = this.querySelector('[role="dialog"]') || this.detailsContainer;
    this.zntKeydownTrap = this.zntKeydownTrap || this.zntTrapFocus.bind(this);
    this.dialog.addEventListener('keydown', this.zntKeydownTrap);
    const input = this.detailsContainer.querySelector('input:not([type="hidden"])');
    if (input) input.focus();
  }

  /* Fix by Zenyth - ZA 42354, 41056, 42343, 41054, 42360, 41061, 42361, 40999, 40980, 41057 (predictive-search dialog a11y) */
  zntTrapFocus(event) {
    if (event.key !== 'Tab') return;
    const focusables = Array.from(
      this.dialog.querySelectorAll(
        'a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, [tabindex]'
      )
    ).filter((el) => {
      if (el.getAttribute('tabindex') === '-1') return false;
      return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
    });
    if (!focusables.length) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  close() {
    /* Fix by Zenyth - ZA 42354, 41056, 42343, 41054, 42360, 41061, 42361, 40999, 40980, 41057 (predictive-search dialog a11y, 2.4.3) */
    if (this.dialog && this.zntKeydownTrap) this.dialog.removeEventListener('keydown', this.zntKeydownTrap);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('search-modal--open');
    if (this.summaryToggle) this.summaryToggle.focus();
    document.dispatchEvent(new CustomEvent('searchmodal:close'));
  }

  reset(event) {
    event.preventDefault();
    this.querySelector('input[type="search"]').value = '';
  }
}

customElements.define('search-modal', SearchModal);

